import { createSelector } from 'reselect';

import { getVideosGroupedByIds } from './videos';
import { getChannelIds } from '@wix/wix-vod-shared/src/common/selectors/channels';

export function getChannelVideoIds(state) {
  return state.channelVideos.ids;
}

export function isFetching(state) {
  return state.channelVideos.activeRequests !== 0;
}


/**
 * @param state
 * @param channelId {String}
 * @returns {Object[]} videos list
 */
export const getChannelVideosByChannelId = createSelector(
  [
    state => getVideosGroupedByIds(state),
    (state, channelId) => channelId,
  ],
  (videoByIds, channelId) =>
    _.filter(videoByIds, video => _.includes(video.usedInLists, channelId)),
);

/**
 * @param state
 * @param channelId {String}
 * @returns {Object[]} videos list
 */
export const getVideosCountByChannelIds = createSelector(
  [
    state => state,
    getChannelIds,
    state => _.partial(getChannelVideosByChannelId, state),
  ],
  (state, channelIds, getVideosByChannelId) =>
    _.zipObject(channelIds, _.map(channelIds, id => _.size(getVideosByChannelId(id)))),
);



// WEBPACK FOOTER //
// ./src/shared/selectors/channel-videos.js